import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// shadcn-standard class combiner: conditional classes (clsx) + conflict
// resolution so a later `h-8` beats an earlier `h-10` (tailwind-merge).
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
